import { useState, useEffect } from "react";
import { Channel } from "pusher-js";

import { useSocket } from "components";
import { ISocketService, useDealActions, useUserIdSelector } from "store";
import { useDealParamsHooks } from "hooks";
import { IFile } from "store/types";

interface IUseDealSocketHook {
  subscribe: () => void;
}

const eventName = "files.checked";
const logoEventName = "files.logoChecked";
const emailUpdatedEvent = "email.updated";

export function useDealSocketHook(): IUseDealSocketHook {
  const [needSubscribe, setNeedSubscribe] = useState<boolean>(false);
  const [channel, setChannel] = useState<Channel | null>(null);
  const [emailsChannel, setEmailsChannel] = useState<Channel | null>(null);

  const { handleFile, setLogoToSaveAction, getEmailsAction } = useDealActions();
  const socket: ISocketService = useSocket();
  const { dealId } = useDealParamsHooks();
  const userId: number | undefined = useUserIdSelector();

  const channelName = `private-scanning-deal-${dealId}-user-${userId}`;
  const emailsChannelName = `private-deal-${dealId}-incoming-emails`;

  // Subscribe
  useEffect(() => {
    if (needSubscribe) {
      setChannel(socket.subscribe(channelName));
      console.log(`[Subscribe for Deal ${dealId}]`);
      setEmailsChannel(socket.subscribe(emailsChannelName));
      console.log(`[Subscribe for deal ${dealId} emails]`);
    }
  }, [needSubscribe]);

  // Unsubscribe
  useEffect(() => {
    return () => {
      socket.unsubscribe(channelName);
      console.log(`[Unsubscribe from Deal ${dealId}]`);
      socket.unsubscribe(emailsChannelName);
      console.log(`[Unsubscribe from deal ${dealId} emails]`);
    };
  }, []);

  useEffect(() => {
    if (channel) {
      channel.bind(eventName, ({ file }: { file: IFile }) => {
        if (userId === file?.user_id) {
          handleFile(file, "update");
        }
      });
    }
  }, [channel]);

  useEffect(() => {
    if (emailsChannel) {
      emailsChannel.bind(emailUpdatedEvent, async () => {
        //refetch deal email box if new email was received
        await getEmailsAction(dealId);
      });
    }
  }, [emailsChannel]);

  useEffect(() => {
    if (channel) {
      channel.bind(logoEventName, ({ logo }: { logo: IFile }) => {
        console.log({ "Logo file WS": logo });
        setLogoToSaveAction(logo);
      });
    }
  }, [channel]);

  return { subscribe: () => setNeedSubscribe(true) };
}
